import { Stack } from "@mantine/core";

import { LayoutStandard } from "components";
import { AuthorityConstants } from "constant";

import F1DeleteUser from './f1';
import F2TruncateDatabase from './f2';
import F3SaveDatabase from './f3';
import F4ResetDatabase from './f4';

const Control = () => {
  return (
    //<LayoutStandard >
    <LayoutStandard authority={AuthorityConstants.ROLE_CONTROL}>
      <Stack justify={'center'} align={'center'} gap={'md'}>
        <F1DeleteUser />
        <F2TruncateDatabase />
        <F3SaveDatabase />
        <F4ResetDatabase />
      </Stack>
    </LayoutStandard>
  )
}

export default Control;